import HelperMixin from "@/mixins/HelperMixin";
import { isCampaignThemeDiscovery, isCampaignThemePerformance } from "@/utils";
import { mapState } from "vuex";
import AppInput from "@/components/AppInput";
import AppSwitch from "@/components/AppSwitch";
import AppPopover from "@/components/AppPopover";
import PercentageValue from "@/components/tableElements/PercentageValue";
import { CurrencyValue } from "@/components/tableElements";
import PpcBudgetAllocationCircle from "@/components/PpcBudgetAllocationCircle";
import AmazonIcon from "@/components/icons/AmazonIcon.vue";
import SettingHexagonIcon from "@/components/icons/SettingHexagonIcon.vue";
import CalendarWithArrowLeftIcon from "@/components/icons/CalendarWithArrowLeftIcon.vue";
import AnnouncementIconNew from "@/components/icons/AnnoncementIconNew.vue";
export default {
  name: "PpcBudgetAllocationHeader",
  emits: ["update:mode", "update:search"],
  mixins: [HelperMixin],
  components: {
    AppInput,
    AppSwitch,
    AppPopover,
    PpcBudgetAllocationCircle,
    PercentageValue,
    CurrencyValue,
    AmazonIcon,
    SettingHexagonIcon,
    CalendarWithArrowLeftIcon,
    AnnouncementIconNew
  },
  props: {
    mode: {
      type: String,
      default: "acos"
    },
    search: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String
    },
    still_initializing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modes: [{
        value: "roas",
        label: "ROAS"
      }, {
        value: "acos",
        label: "ACOS"
      }],
      currency_precision: 0
    };
  },
  computed: {
    ...mapState({
      sp_ppc_campaigns: state => state.ppc_settings.sp_ppc_campaigns,
      sp_product_prioritization_by_campaign_id: state => state.ppc_settings.sp_product_prioritization_by_campaign_id
    }),
    localMode: {
      get() {
        return this.mode;
      },
      set(value) {
        this.$emit("update:mode", value);
      }
    },
    localSearch: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit("update:search", value);
      }
    },
    availableBudget() {
      // TO-DO
      // Neet to get from API
      return 30000;
    },
    perfomanceTotalBudget() {
      // return this.items.reduce((acc, item) => {
      //   return acc + item.perf_allocated_budget_current * 1;
      // }, 0);
      let total_performance_budget = this.sp_ppc_campaigns.filter(ppc_campaign => Object.keys(Object.fromEntries(this.sp_product_prioritization_by_campaign_id)).includes(ppc_campaign.campaignId)).filter(ppc_campaign => ppc_campaign.state == "ENABLED").filter(ppc_campaign => isCampaignThemePerformance(ppc_campaign)).reduce((acc, item) => {
        return acc + item.budget.budget * 7;
      }, 0);
      return total_performance_budget ?? 0;
    },
    performanceTotalVariation() {
      return this.items.reduce((acc, item) => {
        return acc + ((item.is_enabled != 1 ? 0 : item.perf_allocated_budget_current) - item.perf_previous_week_spend * 1);
      }, 0);
    },
    performanceTotalLastWeekSpend() {
      return this.items.reduce((acc, item) => {
        return acc + item.perf_previous_week_spend * 1;
      }, 0);
    },
    discoveryTotalBudget() {
      // return this.items.reduce((acc, item) => {
      //   return (
      //     acc +
      //     (item.discovery_allocated_budget_current ??
      //       item.discovery_allocated_budget_ai) *
      //       1
      //   );
      // }, 0);
      let total_discovery_budget = this.sp_ppc_campaigns.filter(ppc_campaign => Object.keys(Object.fromEntries(this.sp_product_prioritization_by_campaign_id)).includes(ppc_campaign.campaignId)).filter(ppc_campaign => ppc_campaign.state == "ENABLED").filter(ppc_campaign => isCampaignThemeDiscovery(ppc_campaign)).reduce((acc, item) => {
        return acc + item.budget.budget * 7;
      }, 0);
      return total_discovery_budget ?? 0;
    },
    discoveryTotalVariation() {
      return this.items.reduce((acc, item) => {
        return acc + ((item.is_enabled != 1 ? 0 : item.discovery_allocated_budget_current) - item.discovery_previous_week_spend * 1);
      }, 0);
    },
    discoveryTotalLastWeekSpend() {
      return this.items.reduce((acc, item) => {
        return acc + item.discovery_previous_week_spend * 1;
      }, 0);
    },
    totalBudget() {
      return this.perfomanceTotalBudget + this.discoveryTotalBudget ?? 0;
    },
    percent() {
      return this.availableBudget / this.totalBudget * 100;
    }
  }
};